import { Box, Card } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import React from "react";
import styled from "styled-components";
import { TGetServicesCollectionItem } from "../../../../api/service/service.types";
import ServicesList from "./components/ServicesList";
import ServicesPageFilters from "./components/ServicesPageFilters";
import ServicesQuickFiltersTabs from "./components/ServicesQuickFiltersTabs";
import ErrorBox from "./ErrorBox";
import { TServicesPageFilters } from "./hooks/useServicesPageFilters";
import NoServicesFound from "./NoServicesFound";

const StyledPageContainer = styled.div`
  margin: 3rem auto 1rem;
  padding: 1rem;
  max-width: 80rem;
`;

const StyledQuickFiltersWrapper = styled(Card)`
  margin: 0.5rem 0 1rem;
  box-shadow: none;
`;

const StyledListWrapper = styled(Box)``;

const StyledPagination = styled(Pagination)`
  .MuiPagination-ul {
    justify-content: center;
  }
`;

interface IServicesPageNumQuery {
  totalServices: number;
  isLoading: boolean;
  queryError: any;
}

interface IServicesPageProps {
  filters: TServicesPageFilters;
  setFilters: (newFilters: TServicesPageFilters) => void;
  onPageChange: (event: any, newPage: number) => void;
  newServices: IServicesPageNumQuery;
  valuatedServices: IServicesPageNumQuery;
  // followUpServices: IServicesPageNumQuery;
  services: TGetServicesCollectionItem[];
  totalServices: number;
  isLoading: boolean;
  queryError: any;
  onDelaySet: () => void;
}

const ServicesPage = (props: IServicesPageProps) => {
  const {
    filters,
    setFilters,
    onPageChange,
    newServices,
    valuatedServices,
    // followUpServices,
    services,
    totalServices,
    isLoading,
    queryError,
    onDelaySet,
  } = props;

  const handleNewServicesClick = () => {
    setFilters({
      ...filters,
      preset: "new",
    });
  };

  const handleValuatedClick = () => {
    setFilters({
      ...filters,
      preset: "valuated",
    });
  };

  return (
    <StyledPageContainer>
      <ServicesPageFilters
        servicesPageFilters={filters}
        servicesPageSetFilters={setFilters}
      />
      <StyledQuickFiltersWrapper>
        <ServicesQuickFiltersTabs
          value={filters.preset}
          newServices={{
            isLoading: newServices.isLoading,
            totalServices: newServices.totalServices,
          }}
          onNewServicesClick={handleNewServicesClick}
          valuatedServices={{
            isLoading: valuatedServices.isLoading,
            totalServices: valuatedServices.totalServices,
          }}
          onValuatedClick={handleValuatedClick}
          // followUpServices={{
          //   isLoading: followUpServices.isLoading,
          //   totalServices: followUpServices.totalServices,
          // }}
          // onFollowUpClick={handleFollowUpClick}
        />
      </StyledQuickFiltersWrapper>
      <StyledListWrapper>
        {services.length > 0 && (
          <ServicesList
            onDelaySet={onDelaySet}
            services={services}
            isLoading={isLoading}
          />
        )}
      </StyledListWrapper>
      {totalServices > 0 && (
        <StyledPagination
          count={Math.ceil(totalServices / 10)}
          page={filters.page}
          onChange={onPageChange}
          color="primary"
        />
      )}
      {!isLoading && totalServices === 0 && <NoServicesFound />}
      {!!queryError && <ErrorBox />}
    </StyledPageContainer>
  );
};

export default ServicesPage;
